import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

import type { PostEmailIpWarmingDeleteResult } from "./types";

export const isPostEmailIpWarmingDeleteResult = objectOf<PostEmailIpWarmingDeleteResult>({
  success: boolean,
});
